export const GET_ITEMSTATUS_REQUEST = "GET_ITEMSTATUS_REQUEST";
export const GET_ITEMSTATUS_SUCCESS = "GET_ITEMSTATUS_SUCCESS";
export const GET_ITEMSTATUS_FAILURE = "GET_ITEM_TYPE_FAILURE";


export const GET_ITEM_TYPE_REQUEST = "GET_ITEM_TYPE_REQUEST";
export const GET_ITEM_TYPE_SUCCESS = "GET_ITEM_TYPE_SUCCESS";
export const GET_ITEM_TYPE_FAILURE = "GET_ITEM_TYPE_FAILURE";


export const GET_ITEM_TYPE_DOWNLOAD_REQUEST = "GET_ITEM_TYPE_DOWNLOAD_REQUEST";
export const GET_ITEM_TYPE_DOWNLOAD_SUCCESS = "GET_ITEM_TYPE_DOWNLOAD_SUCCESS";
export const GET_ITEM_TYPE_DOWNLOAD_FAILURE = "GET_ITEM_TYPE_DOWNLOAD_FAILURE";

export const GET_ITEM_STATUS_DOWNLOAD_REQUEST = "GET_ITEM_STATUS_DOWNLOAD_REQUEST";
export const GET_ITEM_STATUS_DOWNLOAD_SUCCESS = "GET_ITEM_STATUS_DOWNLOAD_SUCCESS";
export const GET_ITEM_STATUS_DOWNLOAD_FAILURE = "GET_ITEM_STATUS_DOWNLOAD_FAILURE";
